import React, { useEffect, useState } from "react";
import { TextField, Button, CircularProgress } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { sendEmialAPICall } from "../shared/APICalls";
import { ISendEmail } from "../shared/dtos";
import routesData from "../shared/routes.json";
import YourDetailsStyles from "../pages/Styles/YourDetails.module.scss";
import ContinueWithGoogle from "../Components/ContinueWithGoogle/ContinueWithGoogle";
import SnackBar from "../Components/SnackBars/SnackBar";
import firstockLogo from "../Components/assets/Images/Firstocklogo.svg";
import TagManager from "react-gtm-module";
import * as Yup from "yup";

import GooglePlayStore from "../Components/assets/Images/GooglePlayStore.svg";
import AppStore from "../Components/assets/Images/AppStore.svg";
import MicroSoft from "../Components/assets/Images/MicrosoftStore.svg";
import LeftComp from "../Components/LeftComp/LeftComp";
import leftcompimage from "../Components/assets/Images/SignupIllustration.svg";
import fstlogo from "../Components/assets/Images/firstockLogoBadge.svg";
import LeftCompNew from "../Components/LeftCompNew/LeftCompNew";

const schema = Yup.object().shape({
  // name: Yup.string()
  //   .required("Name is Required")
  //   .min(3, "Minmum 3 letters is required")
  //   .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
  //   .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
  //   .max(50)
  //   .transform((value: any) => value && value.toUpperCase()),

  email: Yup.string()
    .required("Email is Required")
    .max(50, "Max 50 characters is allowed")
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Enter Valid Email"),
});

export default function Email() {
  const navigate = useNavigate();

  const [emailAddress, setemailAddress] = useState<any>();
  const [message, setMessage] = useState<any>("");
  const [loading, setloading] = useState(false);

  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  const [mode, setMode] = useState(getSystemTheme());

  useEffect(() => {
    setMode(getSystemTheme());
  }, [getSystemTheme]);

  const navigationData = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);
  }, []);

  function sendEmailAddress(emailid: any) {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitEmail",
        name: "",
        email: emailid,
      },
    });
    let obj: ISendEmail = {
      email: emailid,
    };
    sendEmialAPICall(obj)
      .then((response: any) => {
        sessionStorage.setItem("client-email", emailid);
        const responseData = response.data;
        // console.log(response, "response");

        setloading(false);

        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
        // console.log("error", error);

        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  const callBackMessage = (data: any) => {
    setMessage(data);
  };

  function validateName(value: string) {
    let error = "";

    if (!value.trim()) {
      error = "Name Required";
    } else if (/[^a-zA-Z\s]/.test(value)) {
      error = "Extra characters not allowed";
    } else if (/\s{2,}/.test(value)) {
      error = "Consecutive spaces not allowed";
    } else if (value.length > 50) {
      error = "Max length is 50 characters";
    }

    return error;
  }

  function validateEmail(value: any) {
    let error: string = "";

    if (!value) {
      error = "Email Required";
    } else if (/\s/.test(value)) {
      error = "Email should not contain spaces";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
      error = "Invalid email address";
    } else if (value.length > 75) {
      error = "Not a valid email address";
    }

    return error;
  }

  return (
    <>
      <SnackBar message={message} />
      <div className={YourDetailsStyles.layout}>
        <div className={YourDetailsStyles.sidebar}>
          <LeftCompNew />
        </div>
        <div className={YourDetailsStyles.pageContent}>
          <div className={YourDetailsStyles.wrapper}>
            <div className={YourDetailsStyles.RightContainer}>
              <div className={YourDetailsStyles.contentSection}>
                <div className={YourDetailsStyles.headerSection}>
                  <img
                    src={fstlogo}
                    alt=""
                    className={YourDetailsStyles.fstlogo}
                    // style={{
                    //   filter:
                    //     mode === "dark"
                    //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                    //       : "",
                    // }}
                  />
                  <p className={YourDetailsStyles.signup}>Add Your Email</p>
                  <p className={YourDetailsStyles.subText}>
                    We'll send a verification code to this email to verify your
                    account.
                  </p>
                </div>

                <div className={YourDetailsStyles.imageContainer}>
                  <LeftCompNew />
                </div>

                <Formik
                  initialValues={{
                    email: "",
                  }}
                  validationSchema={schema}
                  onSubmit={(values) => {
                    //  console.log(values);
                    setloading(true);
                    setemailAddress(values.email);
                    sendEmailAddress(values.email);
                  }}
                >
                  {({
                    errors,
                    touched,
                    handleChange,
                    values,
                    handleSubmit,
                    handleBlur,
                  }) => (
                    <form
                      noValidate
                      onSubmit={handleSubmit}
                      onKeyDown={(event) => {
                        event.code === "Enter" && handleSubmit();

                        // event.code.includes("Enter") && handleSubmit()
                      }}
                      style={{ width: "100%", height: "78%" }}
                    >
                      <div className={YourDetailsStyles.feildsWrapper}>
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            marginTop: "10px",
                          }}
                        >
                          <div>
                            <div className={YourDetailsStyles.labeltext}>
                              Enter Your Email ID
                            </div>
                            <TextField
                              autoFocus
                              autoComplete="off"
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                },
                              }}
                              inputProps={{
                                maxLength: 75,
                                onKeyDown: (e) =>
                                  e.key === " " && e.preventDefault(), // Prevents typing space
                                onInput: (e) =>
                                  (e.currentTarget.value =
                                    e.currentTarget.value.replace(/\s/g, "")),
                                sx: {
                                  "&::placeholder": {
                                    paddingLeft: "-40px",
                                    color: "var(--ds-text-secondary)",
                                    fontWeight: 400,
                                    fontStye: "normal",
                                    fontSize: "14px",
                                  },
                                },
                              }}
                              className={YourDetailsStyles.textfeild}
                              name="email"
                              value={values.email}
                              error={touched.email && Boolean(errors.email)}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              id="outlined-basic"
                              label=""
                              placeholder="Email"
                              variant="outlined"
                            />

                            <div
                              style={{
                                color: "#d32f2f",
                                fontSize: "12px",
                                height: "15px",
                                padding: "5px 0px 0px 0px",
                                // textAlign: "center",
                              }}
                            >
                              {errors.email && touched.email && errors.email}
                            </div>
                          </div>
                        </div>
                        <div className={YourDetailsStyles.googleMobile}>
                          <div className={YourDetailsStyles.orsection}>
                            <div className={YourDetailsStyles.dash}></div>
                            or <div className={YourDetailsStyles.dash}></div>
                          </div>
                          <ContinueWithGoogle
                            handleCallBack={callBackMessage}
                            handleCallBackSuccess={() => {}}
                          />
                        </div>

                        {/* <div className={YourDetailsStyles.descriptionMobile}>
                          <div className={YourDetailsStyles.text1}>
                            Firstock Broking (P) Ltd: NSE & BSE - SEBI
                          </div>
                          <div className={YourDetailsStyles.text1}>
                            Registration No. INZ000260334
                            | CDSL - SEBI Registration No : IN-
                          </div>
                          <div className={YourDetailsStyles.text1}>
                            DP-67-2015 | Mutual Fund ARN: 132812 | Smart Online
                            Dispute
                          </div>
                          <div className={YourDetailsStyles.text1}>
                            Resolution | SEBI SCORES
                          </div>
                        </div> */}

                        <div className={YourDetailsStyles.buttonSection}>
                          {values.email ? (
                            <LoadingButton
                              variant="contained"
                              type="submit"
                              loading={loading}
                              id="yourDetailsContinueButton"
                              loadingIndicator={
                                <CircularProgress
                                  sx={{ color: "#000" }}
                                  size={16}
                                />
                              }
                              className={YourDetailsStyles.button}
                              onClick={() => {
                                handleSubmit();
                              }}
                            >
                              Continue
                            </LoadingButton>
                          ) : (
                            <Button
                              variant="contained"
                              disabled
                              className={YourDetailsStyles.button}
                            >
                              Continue
                            </Button>
                          )}

                          <div className={YourDetailsStyles.googleDesktop}>
                            <ContinueWithGoogle
                              handleCallBack={callBackMessage}
                              handleCallBackSuccess={() => {}}
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>

            <div className={YourDetailsStyles.cardFooter}>
              <div className={YourDetailsStyles.footerLinks}>
                <a
                  className={YourDetailsStyles.footerItem}
                  href="https://firstock.in/faq/"
                  target="_blank"
                  rel="noreferrer"
                >
                  FAQ
                </a>
                <span
                  className={YourDetailsStyles.footerSep}
                  aria-hidden="true"
                >
                  ·
                </span>
                <a
                  className={YourDetailsStyles.footerItem}
                  href="https://firstock.in/support/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Support
                </a>
              </div>

              <p className={YourDetailsStyles.termsAck}>
                By continuing, you agree to our{" "}
                <a
                  href="https://firstock.in/terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms
                </a>{" "}
                &amp;{" "}
                <a
                  href="https://firstock.in/privacy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </p>
            </div>
            {/* <div className={YourDetailsStyles.firstockApps}>
              <div className={YourDetailsStyles.apps}>
                <a
                  href="https://play.google.com/store/apps/details?id=in.firstock.mobile"
                  target="_blank"
                >
                  <img
                    src={GooglePlayStore}
                    className={YourDetailsStyles.Googlestoreimage}
                  />
                </a>

                <a
                  href="https://apps.apple.com/us/app/firstock-trade-invest/id6746480444"
                  target="_blank"
                >
                  <img
                    src={AppStore}
                    className={YourDetailsStyles.Appstoreimage}
                  />
                </a>

                <a href="https://firstock-common.s3.ap-south-1.amazonaws.com/app/Firstock_INV_Live_Firstock_2023.7.4-setup.zip">
                  <img
                    src={MicroSoft}
                    className={YourDetailsStyles.Microstoreimage}
                  />
                </a>
              </div>
              <div className={YourDetailsStyles.description}>
                <div className={YourDetailsStyles.text1}>
                  Firstock Broking (P) Ltd: NSE & BSE - SEBI
                </div>
                <div className={YourDetailsStyles.text1}>
                  Registration No. INZ000260334 | CDSL - SEBI Registration No :
                  IN-
                </div>
                <div className={YourDetailsStyles.text1}>
                  DP-67-2015 | Mutual Fund ARN: 132812 | Smart Online Dispute
                  Resolution | SEBI SCORES
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
